// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type CreateInvoiceMutationVariables = Types.Exact<{
  upsertInvoiceDTO: Types.UpsertInvoiceDtoInput;
  additionalProducts: Types.InputMaybe<Array<Types.InputMaybe<Types.UpsertInvoiceAdditionalProductDtoInput>> | Types.InputMaybe<Types.UpsertInvoiceAdditionalProductDtoInput>>;
}>;


export type CreateInvoiceMutationResult = { __typename?: 'Mutation', createInvoice: number | null };

export const CreateInvoiceGql = gql`
    mutation CreateInvoice($upsertInvoiceDTO: UpsertInvoiceDTOInput!, $additionalProducts: [UpsertInvoiceAdditionalProductDTOInput]) {
  createInvoice(
    upsertInvoiceDTO: $upsertInvoiceDTO
    additionalProducts: $additionalProducts
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateInvoiceInjectable extends Apollo.Mutation<CreateInvoiceMutationResult, CreateInvoiceMutationVariables> {
    override document = CreateInvoiceGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */